const topMain = () => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    const secMain = document.getElementById('jsSecMain');

    const mainWrap = secMain.querySelector('.js-main-wrap');

    const slideAreaBg = mainWrap.querySelector('.js-slide-area-bg');
    const slideArea = mainWrap.querySelector('.js-slide-area');
    const logoArea = mainWrap.querySelector('.js-logo-area');
    const scrollArea = mainWrap.querySelector('.js-scroll-area');



    // pin
    {
      let to = gsap.to(mainWrap, {
        ease: "none",
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: mainWrap,
          start: '0% 0%',
          endTrigger: secMain,
          end: '100% 100%',
          pin: true,
          // markers: true
        }
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          to.scrollTrigger.refresh()
          // console.log('comParallax refresh');
        });
      });
      observer.observe(target);
    }



    // パスオフ
    {
      let tl = gsap.timeline({
        scrollTrigger: {
          invalidateOnRefresh: true,
          trigger: secMain,
          start: "50px 0%",
          onEnter: () => {
            slideArea.classList.add('off')
            slideAreaBg.classList.add('on')
            // logoArea.classList.add('act')
          },
          // onLeave: () => console.log("onLeave"),
          // onEnterBack: () => console.log("onEnterBack"),
          onLeaveBack: () => {
            slideArea.classList.remove('off')
            slideAreaBg.classList.remove('on')
            // logoArea.classList.remove('act')
          },
          // markers: true,
        },
      })


      let target = document.querySelector('body');
      let observer = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          tl.scrollTrigger.refresh()
        });
      });
      observer.observe(target);
    }



    // スタート
    {
      setTimeout(() => {
        slideArea.classList.add('act')
        logoArea.classList.add('act')
        setTimeout(() => {
          scrollArea.classList.add('act')
        }, 800);
      }, 1200);
    }





  }
}
export default topMain;